module.exports = __webpack_public_path__ + "static/img/wb.2d08060.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wb.jpg
// module id = yumz
// module chunks = 8